import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const EditBook = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bookDetails, setBookDetails] = useState({
    title: "",
    author: "",
    publisher: "",
    stock: 0,
    price: 0,
    image: "", // Store image URL from database
  });
  const [newImage, setNewImage] = useState(null); // For new file selection
  const [notification, setNotification] = useState(null);
  
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  // Fetch book details when the component mounts
  useEffect(() => {
    const fetchBookDetails = async () => {
      try {
        const response = await fetch(`${config.BASE_URL}/api/register-book/${id}/`);
        if (response.ok) {
          const data = await response.json();
          setBookDetails({
            ...data,
            image: data.image ? `${config.BASE_URL}${data.image}` : "", // Ensure full URL
          });
        } else {
          console.error("Failed to fetch book details");
        }
      } catch (error) {
        console.error("Error fetching book details:", error);
      }
    };
    fetchBookDetails();
  }, [id]);
  console.log("Book Image URL:", bookDetails.image);

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewImage(file); // Store the new selected file separately
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", bookDetails.title);
    formData.append("author", bookDetails.author);
    formData.append("publisher", bookDetails.publisher);
    formData.append("stock", bookDetails.stock);
    formData.append("price", bookDetails.price);

    if (newImage) {
      formData.append("image", newImage); // Only append if a new file is selected
    }

    try {
      const response = await fetch(`${config.BASE_URL}/api/register-book/${id}/`, {
        method: "PUT",
        body: formData,
      });

      if (response.ok) {
        setNotification({ type: "success", message: "Book updated successfully!" });
        setTimeout(() => navigate("/view-books"), 3000);
      } else {
        const errorData = await response.json();
        setNotification({ type: "error", message: errorData.error || "Failed to update the book." });
      }
    } catch (error) {
      console.error("Error updating the book:", error);
      setNotification({ type: "error", message: "An error occurred. Please try again." });
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand text-light" href="#">Admin</a>
        <button 
          className="navbar-toggler bg-light" 
          type="button" 
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
            <li className="nav-item">
              <Link className="nav-link text-light" to="/admin">
                <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/register-book">
                <FontAwesomeIcon icon={faBook} className="me-2 " />
                Register Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/list-users">
                <FontAwesomeIcon icon={faUsers} className="me-2" />
                Manage User
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/view-books">
                <FontAwesomeIcon icon={faListCheck} className="me-2" />
                Manage Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminpurchase">
                <FontAwesomeIcon icon={faCartShopping} className="me-2 text-warning" />
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminrent">
                <FontAwesomeIcon icon={faBagShopping} className="me-2" />
                Rental History
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <Link className="nav-link text-light fixed-right" to="/login">
                <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
<div className="container edit-book-container mt-5 pt-5">
      <h2 className="text-center mb-4">Edit Book Details</h2>

      
  {notification && (
        <div
          style={{
            position: "fixed",
            top: "30px",
            right: "20px",
            backgroundColor: notification.type === "success" ? "#28a745" : "#dc3545",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
          }}
        >
          {notification.message}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="form-container">
      <div className="mb-3">
        <label className="form-label">Book Title</label>
        <input type="text" className="form-control" name="title" value={bookDetails.title} onChange={handleChange} required />
      </div>
      <div className="mb-3">
        <label className="form-label">Author</label>
        <input type="text" className="form-control" name="author" value={bookDetails.author} onChange={handleChange} required />
      </div>
      <div className="mb-3">
        <label className="form-label">Publisher</label>
        <input type="text" className="form-control" name="publisher" value={bookDetails.publisher} onChange={handleChange} required />
      </div>
      <div className="mb-3">
        <label className="form-label">Stock</label>
        <input type="number" className="form-control" name="stock" value={bookDetails.stock} onChange={handleChange} required />
      </div>
      <div className="mb-3">
        <label className="form-label">Price</label>
        <input type="number" className="form-control" name="price" value={bookDetails.price} onChange={handleChange} required />
      </div>

      {/* Display existing image if available */}
      {bookDetails.image && (
        <div className="mb-3">
          <label className="form-label">Current Book Image</label>
          <div>
            <img src={bookDetails.image} alt="Book Cover" className="img-thumbnail" style={{ maxWidth: "200px" }} />
          </div>
        </div>
      )}

      {/* File input for new image */}
      <div className="mb-3">
        <label className="form-label">Upload New Book Image</label>
        <input type="file" className="form-control" name="image" onChange={handleImageChange} />
      </div>

      <button type="submit" className="btn btn-primary w-100">
        Update Book
      </button>

      {/* Notification */}
      {notification && (
        <div className={`alert alert-${notification.type === "success" ? "success" : "danger"} mt-3`}>
          {notification.message}
        </div>
      )}
    </form>
    </div>

      
      <style jsx>{`
 .edit-book-container {
  max-width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

 .form-container {
   max-width: 500px;
   width: 100%;
   padding: 20px;
   border-radius: 10px;
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
 }

 
       .content {
         margin-left: 200px;
       }
       @media (max-width: 768px) {
         .vertical-nav {
           width: 100%;
         }
         .content {
           margin-left: 0;
         }
       }
 .navbar {
   background: #1a1a1a; /* Dark background color */
 }

 .vertical-nav {
   background: #1a1a1a; /* Dark background color */
   position: fixed;
   top: 56px;
   left: 0;
   height: calc(100% - 56px);
   overflow-y: auto;
   padding-top: 30px;
   z-index: 999;
 }

 .vertical-nav .nav-link {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   padding: 10px 15px;
   color: #ff6700; /* Dark orange font color */
   transition: background-color 0.3s; /* Smooth hover effect */
 }

 .vertical-nav .nav-link:hover {
   background-color: #2a2a2a; /* Slightly lighter background for hover effect */
 }

 .nav-icon {
   font-size: 20px;
   margin-right: 10px;
   color: #ff6700; /* Dark orange for icons */
 }

 li {
   border-bottom: 2px solid black;
 }

 li:hover {
   background-color: #2a2a2a; /* Slightly lighter background for hover effect */
 }


 .btn {
   width: 100%; /* Full-width button */
   background-color: #ff6700; /* Dark orange background for button */
    maxWidth: 400px,

   color: white;
   border: none;
   padding: 10px;
   font-size: 16px;
   font-weight: bold;
   border-radius: 5px;
 }

 .btn:hover {
   background-color: #e65c00; /* Darker orange on hover */
   cursor: pointer;
 }

 body {
   position: relative;
   margin: 0; /* Remove default margins */
   padding: 0; /* Remove default padding */
 }

 body::before {
   content: '';
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
   background-size: cover; /* Ensure the image covers the entire body */
   opacity: 0.4; /* Apply opacity only to the image */
   z-index: -1; /* Place it behind all other content */
 }

 a {
   text-decoration: none;
 }

 h1, h2, h3, h4, h5, h6 {
   font-family: "Times New Roman", Times, serif; /* Classic font */
   color: #1a1a1a; /* Match the theme color */
 }
     `}</style>
    </div>
  );
};

export default EditBook;
